/* eslint-disable */
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  FULLTIME_OPTION
} from "../../common/constants/dropdownOptions";
import {
  getDropdownOptionForFullTime,
  getLookupOptionLabelNew
} from "../../helpers/LookupOptionHelper";
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/advertisementTable.css";
import "../../styles/profile.css";
import {
  clearEditExperienceInfo,
  getDetailsForEditExperience,
  setExperienceTableList,
} from "../actions/profileAction";
import { experienceInfoReqDTO } from "../constants/experienceInfoReqDTO";
import common from "../labels/common_en.json";
import experienceinformation from "../labels/experience_information_en.json";

const ExperienceTabTable = (props) => {


  let {
    profileStatus,
    experiencesList,
    profileCreationAllLookupData,
    getJobDesignationList,
  } = useSelector((state) => state.profile, shallowEqual);
  const dispatch = useDispatch();
  let [showModal, setShowModal] = useState(false);
  let [deleteIndex, setDeleteIndex] = useState("");
  let [expList, setExpList] = useState([]);

  const [buttons, setButtons] = useState(false);


  let deleteExperienceRow = (experienceRowIndex) => {
    experiencesList[experienceRowIndex].isDeleted = 1;
    toastr.info(experienceinformation.EXPERIENCE_DELETED_NOTE);
    if (experiencesList[experienceRowIndex].id) {
      expList.splice(experienceRowIndex, 1);
    } else {
      experiencesList.splice(experienceRowIndex, 1);
    }
    dispatch(clearEditExperienceInfo(experienceInfoReqDTO));
  };

  let editExperienceRow = (experienceRowIndex) => {
    props.setIsChangeFrom(false);
    props.setIsChangeTo(false);
    let experienceToBeEdited = experiencesList[experienceRowIndex];
    dispatch(getDetailsForEditExperience(experienceToBeEdited));
  };

  const modalConfirm = () => {
    deleteExperienceRow(deleteIndex);
    setDeleteIndex("");
    setShowModal(false);
  };

  const showDropdown = (id) => {
    var dropdowns = document.getElementsByClassName("actiondropdown-content");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains("actionshow")) {
        openDropdown.classList.remove("actionshow");
      }
    }
    document.getElementById(id).classList.toggle("actionshow");
  };

  useEffect(() => {
    window.onclick = function (event) {
      if (!event.target.matches(".dropbtn")) {
        var dropdowns = document.getElementsByClassName(
          "actiondropdown-content"
        );
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains("actionshow")) {
            openDropdown.classList.remove("actionshow");
          }
        }
      }
    };
  }, []);
  useEffect(() => {
    if (experiencesList && experiencesList.length > 0) {
      let list = [];
      experiencesList.map((ele) => {
        list.push(ele);
      });
      setExpList(list);
      dispatch(setExperienceTableList(list));
    }
  }, [experiencesList]);



  const experienceInfoList =
    props.enableEditProfileWithLock?.editProfileWithLock == "1"
      ? props.enableEditProfileWithLock?.ExperienceInfo?.split(",")
      : [];

  const canEdit = experienceInfoList?.includes("U");
  const canDelete = experienceInfoList?.includes("D");

  // Only show UI if at least one of them is true
  const showThreeDots = canEdit || canDelete;


  return (
    <div className="border border-light text-center">
      <table className="table table-bordered m-0 position-relative experienceTable">
        <thead>
          <tr>
            {experienceinformation.experienceHeaderContent.map((ele, index) => (
              <th scope="col" key={index} className="bg-blue text-white">
                {ele}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="f12">
          {expList.map((ele, index) => {
            if (!ele.isDeleted) {
              return (
                <tr key={index}>
                  <td className="word-break">{index + 1}</td>
                  <td className="word-break">{(ele.officeName).toUpperCase()}</td>
                  <td className="word-break">{ele && ele.designation ? ele.designation : "N/A"}</td>
                  <td className="word-break">
                    {getLookupOptionLabelNew(
                      ele.apointmentNatureLookupId,
                      profileCreationAllLookupData
                    )}
                  </td>
                  <td className="word-break">
                    {getLookupOptionLabelNew(
                      ele.jobNatureLookupId,
                      profileCreationAllLookupData
                    )}
                  </td>
                  <td className="word-break">
                    {getDropdownOptionForFullTime(
                      ele.fullTimeLookupId,
                      FULLTIME_OPTION
                    ) ? getDropdownOptionForFullTime(
                      ele.fullTimeLookupId,
                      FULLTIME_OPTION
                    ) : "N/A"}
                  </td>
                  <td className="word-break">{ele.payScale ? ele.payScale : "N/A"}</td>
                  <td className="word-break">{ele.gradePay ? ele.gradePay : "N/A"}</td>
                  <td className="word-break">{ele.monthlyGrossSalary ? ele.monthlyGrossSalary : "N/A"}</td>
                  <td className="word-break">
                    {ele.employmentFrom
                      ? dayjs(ele.employmentFrom).format(
                        commonLabels.DATE_FORMAT
                      )
                      : "N/A"}
                  </td>
                  <td className="word-break">
                    {ele.employmentTo
                      ? dayjs(ele.employmentTo).format(commonLabels.DATE_FORMAT)
                      : ""}
                  </td>
                  <td className="word-break">{ele.expYears}</td>
                  <td className="word-break">{ele.expMonths}</td>
                  <td className="word-break">{ele.expDays}</td>
                  <td className="word-break">
                    {getLookupOptionLabelNew(
                      ele.institutionLookupId,
                      profileCreationAllLookupData
                    )}
                  </td>
                  {/* <td className="word-break">
                    {getDropdownForBpscSelection(
                      ele.isBpscSelection,
                      BOOLEAN_OPTION
                    ) ? getDropdownForBpscSelection(
                      ele.isBpscSelection,
                      BOOLEAN_OPTION
                    ) : "N/A"}
                  </td> */}
                  {/* condition to display buttons and 3 dots */}

                  {props.activeIntershipIndex !== index ? (
                    <td className="word-break">
                      {profileStatus !== true ? (
                        <button
                          onClick={() => props.setActiveIntershipIndex(index)}
                          data-toggle="tooltip"
                          title="Edit and Delete"
                        >
                          <PiDotsThreeOutlineVerticalFill />
                        </button>
                      ) : (
                        showThreeDots && (
                          <button
                            onClick={() => props.setActiveIntershipIndex(index)}
                            data-toggle="tooltip"
                            title="Edit and Delete"
                          >
                            <PiDotsThreeOutlineVerticalFill />
                          </button>
                        )
                      )}
                    </td>
                  ) : (
                    <td className="word-break edit_delete_button">
                      {profileStatus !== true ? (
                        <>
                          <i
                            className="fas fa-pen-to-square edit-icon"
                            data-toggle="tooltip"
                            title={
                              profileStatus
                                ? common.EDIT_DISALLOWED_TOOLTIP
                                : common.EDIT_TOOLTIP
                            }
                            onClick={() => {
                              editExperienceRow(index);
                            }}
                          />
                          <i
                            className="fas fa-trash edit-icon"
                            data-toggle="tooltip"
                            title={
                              profileStatus
                                ? common.DELETE_DISALLOWED_TOOLTIP
                                : common.DELETE_TOOLTIP
                            }
                            onClick={() => {
                              setShowModal(true);
                              setDeleteIndex(index);
                            }}
                          />
                        </>
                      ) : (
                        showThreeDots && (
                          <>
                            {canEdit && (
                              <i
                                className="fas fa-pen-to-square edit-icon"
                                data-toggle="tooltip"
                                title={
                                  profileStatus
                                    ? common.EDIT_DISALLOWED_TOOLTIP
                                    : common.EDIT_TOOLTIP
                                }
                                onClick={() => {
                                  editExperienceRow(index);
                                }}
                              />
                            )}
                            {canDelete && (
                              <i
                                className="fas fa-trash edit-icon"
                                data-toggle="tooltip"
                                title={
                                  profileStatus
                                    ? common.DELETE_DISALLOWED_TOOLTIP
                                    : common.DELETE_TOOLTIP
                                }
                                onClick={() => {
                                  setShowModal(true);
                                  setDeleteIndex(index);
                                }}
                              />
                            )}
                          </>
                        )
                      )}
                    </td>
                  )
                  }




                  <td className="word-break">
                    {/* <img src="/icons/tickIcon.png" width="20" height="20" /> */}
                    <img src="/icons/cross.png" width="20" height="20" />
                  </td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>
      {expList && expList.length === 0 ? (
        <h6 className="text-muted text-center">
          {commonLabels.NO_DATA_TO_DISPLAY}
        </h6>
      ) : (
        ""
      )}
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        backdrop="static"
      >
        <Modal.Header className="custom-modal-header logout_heading">
          <Modal.Title className="logout_title">
            {experienceinformation.DELETE_EXPERIENCE_MODAL_TITLE}
          </Modal.Title>
          <button
            type="button"
            className="ms-auto logout_close"
            aria-label="Close"
            onClick={() => setShowModal(false)}
          >X</button>
        </Modal.Header>
        <Modal.Body>
          <label>
            {experienceinformation.DELETE_EXPERIENCE_CONFIRMATION_MESSAGE}
          </label>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setShowModal(false);
            }}
          >
            {common.CANCEL}
          </button>
          <button className=" btn btn-primary custom_button   " onClick={modalConfirm}>
            {common.CONFIRM}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ExperienceTabTable;